<script setup lang="ts">
</script>

<template>
  <div
    class="absolute z-navbar"
    style="
      border-bottom: 10px solid white;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      height: 0;
      right: 12px;
      top: 4px;
      width: 0;
"
  />
</template>
